type CloseV12Props = {
  fill?: string
}

export const CloseV12 = ({ fill = 'black' }: CloseV12Props) => {
  const fillColor = fill === 'white' ? '#fff' : '#000'

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
      <path stroke={fillColor} d="m1 1 10 10M1 11 11 1" />
    </svg>
  )
}
